<template>
  <div class="table-notas">
    <Loader :loading="httpSend">
      <!-- Filtros Card -->
      <div class="table-card p-4 mb-section">
        <div class="row">
          <div class="col-xl-3 col-sm-6">
            <label class="card-radio-label mb-0">
              <input type="radio" name="pay-method"
                     id="pay-methodoption1"
                     @change="alterFilter('open')"
                     v-bind:checked="filtro.open"
                     :value="true"
                     v-model="filtro.open"
                     class="card-radio-input">
              <div class="card-radio">
                <i class="fas fa-money-bill font-size-24 text-primary align-middle mr-2"></i>
                <span>Em Aberto</span>
              </div>
            </label>
          </div>
          <div class="col-xl-3 col-sm-6">
            <label class="card-radio-label mb-0">
              <input type="radio" name="pay-method"
                     @change="alterFilter('all')"
                     id="pay-methodoption3"
                     :value="true"
                     v-model="filtro.all"
                     v-bind:checked="filtro.all"
                     class="card-radio-input">
              <div class="card-radio">
                <i class="fas fa-money-check-alt font-size-24 text-primary align-middle mr-2"></i>
                <span>Todas as DUAMs</span>
              </div>
            </label>
          </div>
        </div>
      </div>

      <!-- SEM DUAMs MESSAGE -->
      <div v-show="!list_guias || list_guias.length < 1" class="empty-state-card table-card mb-section">
        <div class="empty-state">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
            <circle cx="18" cy="18" r="17" stroke="#e2e8f0" stroke-width="1.5"/>
            <path d="M12 18h12M18 12v12" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <p>Nenhuma DUAM encontrada</p>
        </div>
      </div>

      <!-- TABELA DE DUAMs -->
      <div class="table-card mb-section" v-if="list_guias && list_guias.length > 0">
        <div class="table-header">
          <div class="header-left-group">
            <p class="chart-title"><i class="bx bx-receipt mr-1 text-primary"></i> DUAMs Geradas</p>
            <span class="badge-count">{{ list_guias.length }} registros</span>
          </div>
        </div>
        <div class="table-wrapper">
          <table class="nf-table row-border-bottom">
            <thead>
              <tr>
                <th>DUAM</th>
                <th>Competência</th>
                <th>Tributo</th>
                <th>Vencimento</th>
                <th class="td-right">Valor Original</th>
                <th class="td-right">Total Atualizado</th>
                <th class="td-right">Valor Pago</th>
                <th class="th-status">Situação</th>
                <th class="td-right th-action">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="g in paginated_guias" :key="g.dam_codigo" :class="{ 'row--warning': (g.tab_codigo ==='963' || g.tab_codigo ==='964') && !g.pagamento }">
                <td class="td-mono td-bold">{{ g.dam_codigo }}</td>
                <td>{{ g.dam_mes_ref }}/{{ g.dam_ano_ref }}</td>
                <td>{{ g.tip_nome }}</td>
                <td>
                  <span class="vencimento-wrap" style="color: #475569;">
                    <strong>{{ g.dam_data_venc_atu | formatDate }}</strong>
                  </span>
                </td>
                <td class="td-mono td-right text-muted" style="white-space: nowrap;">{{ g.dut_valortributo | formatNumeroBr }}</td>
                <td class="td-mono td-right font-weight-bold" style="white-space: nowrap; color: #dc2626;">{{ g.dut_valortotal | formatNumeroBr }}</td>
                <td class="td-mono td-right font-weight-bold" :class="{ 'text-success': g.pagamento }" style="white-space: nowrap;">
                  <span v-if="g.pagamento">{{ g.pagamento.bab_valor_pago | formatNumeroBr }}</span>
                  <span v-else>-</span>
                </td>
                <td class="text-left" style="white-space: nowrap;">
                  <span v-if="g.pagamento" class="status-badge status-badge--autorizada">{{ g.tab_nome }}</span>
                  <span v-else-if="g.tab_codigo ==='965'" class="status-badge status-badge--cancelada">{{ g.tab_nome }}</span>
                  <span v-else class="status-badge status-badge--pendente">{{ g.tab_nome }}</span>
                </td>
                <td class="td-action text-right" style="white-space: nowrap;">
                  <button v-if="(g.tab_codigo ==='963' || g.tab_codigo ==='964') && !g.pagamento" @click="pagamento(g)" class="btn-icon shadow-none border-0 bg-transparent text-success mr-1" v-b-tooltip.hover title="Realizar Pagamento">
                    <i class="bx bx-money font-size-18"></i>
                  </button>
                  <b-dropdown variant="light" size="sm" right no-caret toggle-class="btn-icon shadow-none border-0 text-muted bg-transparent">
                    <template #button-content>
                      <i class="bx bx-dots-vertical-rounded font-size-18"></i>
                    </template>
                    
                    <b-dropdown-item v-if="(g.tab_codigo ==='963' || g.tab_codigo ==='964') && !g.pagamento" @click="pagamento(g)">
                      <i class="bx bx-money mr-2 text-success"></i> Realizar Pagamento
                    </b-dropdown-item>

                    <b-dropdown-item v-if="(g.tab_codigo ==='963' || g.tab_codigo ==='964') && !g.pagamento && tipo_arrecadacao === 99" @click="guiaDetalhe(g)">
                      <i class="bx bx-printer mr-2 text-primary"></i> Espelho da DUAM
                    </b-dropdown-item>
                    
                    <b-dropdown-item v-if="g.pagamento" @click="printComprovante(g)">
                      <i class="bx bx-printer mr-2 text-info"></i> Comprovante de Pagamento
                    </b-dropdown-item>

                    <b-dropdown-item @click="guiaDetalhe(g)">
                      <i class="bx bx-show-alt mr-2 text-dark"></i> Ver Detalhes
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-show="list_guias && list_guias.length > 0" class="row">
        <div class="col-lg-12 d-flex justify-content-center">
          <paginate
              v-model="filtro.pagina"
              :page-count="total_paginas"
              :page-range="3"
              :margin-pages="3"
              :click-handler="proximaPagina"
              :prev-text="'‹ Anterior'"
              :next-text="'Próxima ›'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :container-class="'pagination pagination-rounded mt-4 mb-4'"
              :page-class="'page-item'">
          </paginate>
        </div>
      </div>

    </Loader>
  </div>
</template>
<script>
import Loader from "@/components/widgets/loader";
import {listGuias} from "@/api/financeiro/guia";
import {impressao} from "@/helps/impressao";
import {getFinanceiroComprovante} from "@/api/relatorio/financeiro";
import Paginate from 'vuejs-paginate';

export default {
  components: {
    Loader,
    Paginate
  },
  data() {
    return {
      total_paginas: 0,
      list_guias: [],
      filtro: {
        open: true,
        all: false,
        pagina: 1,
        guia_pagina: 10
      },
      httpSend: false,
    };
  },
  created() {
    if (this.empresa) {
      this.getGuia();
    }
  },
  computed: {
    tipo_arrecadacao: {
      get: function () {
        return parseInt(this.$store.state.auth.currentEntidade.par_tipo_cobranca);
      },
    },
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
    paginated_guias() {
      return this.list_guias;
    }
  },
  methods: {
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = pageNum;
      this.getGuia();
    },
    getGuia() {
      this.httpSend = true;
      listGuias(this.empresa.eco_codigo, this.filtro).then(result => {
        this.list_guias = result.dados.guias;
        this.total_paginas = result.dados.paginas;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    alterFilter(tipo) {
      if (tipo === 'open') {
        this.filtro.open = true;
        this.filtro.all = false
      } else {
        this.filtro.open = false;
        this.filtro.all = true
      }
      this.getGuia();
    },
    guiaDetalhe(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-guia-detalhe",
        params: {dam_hash: guia.dam_hash}
      })
    },
    pagamento(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-pagamento",
        params: {dam_hash: guia.dam_hash}
      })
    },
    printComprovante(guia) {
      this.httpSend = true;
      impressao(getFinanceiroComprovante(guia.dam_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    }
  }
};
</script>


<style scoped>
/* Dashboard Styling Tokens */
.mb-section { margin-bottom: 8px; }

.table-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.table-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f1f5f9;
  display: flex; align-items: center; justify-content: space-between;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.chart-title { margin: 0; font-size: 14px; font-weight: 600; color: #1e293b; display: flex; align-items: center; }
.badge-count { font-size: 11px; font-weight: 500; color: #64748b; background: #f1f5f9; border-radius: 999px; padding: 2px 10px; margin-left: 10px; }

.table-wrapper { 
  padding-bottom: 30px; 
  overflow-x: auto; 
  -webkit-overflow-scrolling: touch; 
}

.nf-table { width: 100%; min-width: 900px; border-collapse: collapse; font-size: 12px; }
.nf-table thead th {
  background: #f8fafc;
  padding: 10px 1rem;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e2e8f0;
}
.nf-table tbody td {
  padding: 5px 0.5rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.nf-table tbody tr:hover { background: #f8fafc; }
.row--cancelada td { background-color: #f9e9e980; }
.row--warning td { background-color: #fffbeb !important; }

.td-bold { font-weight: 600; color: #0f172a; }
.td-right, .th-right { text-align: right; }

/* Largura da coluna Ações (Altere o valor de 60px abaixo caso ache necessário) */
.th-action { width: 80px; }

/* Largura da coluna Status/Situação (Altere o valor abaixo caso ache necessário) */
.th-status { width: 110px; }

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}
.status-badge--autorizada { background: #22c55e1a; color: #166534; border: 1px solid #bbf7d0; }
.status-badge--pendente { background: #f59e0b1a; color: #92400e; border: 1px solid #fde68a; }
.status-badge--cancelada { background: #ef44441a; color: #991b1b; border: 1px solid #fecaca; }

.btn-icon {
  width: 32px; height: 32px;
  border: none; border-radius: 8px;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 16px; cursor: pointer; transition: all 0.2s;
}

.empty-state { text-align: center; padding: 3rem 1.5rem; color: #64748b; }
.empty-state svg { margin-bottom: 12px; }
</style>
